import { types } from '../../../types/types'
import { startSpinner, finishSpinner } from "../../ui/spinner";
import TipoDocumentacionesEfectorService from '../../../services/TipoDocumentacionesEfectorService'
import { startAlerta } from '../../ui/alertas';

export const limpiarTipoDocumentacionPorSubtipoEfector = () => ({ type: types.tipoDocumentacionPorSubTipoEfectorLimpiar });

export const traerTipoDocumentacionPorSubtipoEfector = (id) =>  async (dispatch) => {
    dispatch(startSpinner())
    dispatch({ type: types.tipoDocumentacionPorSubTipoEfector })
    try {
        const result = await TipoDocumentacionesEfectorService.traerPorSubtipoEfector(id)
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.tipoDocumentacionPorSubTipoEfectorTraerSuccess,
                payload: body
            })
            dispatch(finishSpinner())
        } else {
            throw body
        }

    } catch (error) {
        dispatch({ type: types.tipoDocumentacionPorSubTipoEfectorTraerError })
        dispatch(finishSpinner())
        if (error.errores && error.errores.mensaje) {
            dispatch(startAlerta(error.errores.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
};

export const crearRelacionDocumentacionSubtipoEfector = (data) =>  async (dispatch) => {
  dispatch(startSpinner())
  try {
      const result = await TipoDocumentacionesEfectorService.crearRelacionDocumentacionSubtipoEfector(data)
      const body = await result.json()
      if (result.ok) {
          dispatch({
              type: types.tipoDocumentacionPorSubTipoEfectorCrear,
              payload: body
          })
          dispatch(finishSpinner())
      } else {
          throw body
      }

  } catch (error) {
      dispatch(finishSpinner())
      if (error.errores && error.errores.mensaje) {
          dispatch(startAlerta(error.errores.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
};

export const modificarTipoDocumentacionPorSubtipoEfector = (id, data) =>  async (dispatch) => {
  dispatch(startSpinner())
  try {
      const result = await TipoDocumentacionesEfectorService.actualizarRelacionDocumentacionSubtipoEfector(id, data)
      const body = await result.json()
      if (result.ok) {
          dispatch({
              type: types.tipoDocumentacionPorSubTipoEfectorModificar,
              payload: body
          })
          dispatch(finishSpinner())
      } else {
          throw body
      }

  } catch (error) {
      dispatch(finishSpinner())
      if (error.errores && error.errores.mensaje) {
          dispatch(startAlerta(error.errores.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
};

export const eliminarTipoDocumentacionPorSubtipoEfector = (id) =>  async (dispatch) => {
  dispatch(startSpinner())
  try {
      const result = await TipoDocumentacionesEfectorService.eliminarRelacionDocumentacionSubtipoEfector(id)
      const body = await result.json()
      if (result.ok) {
          dispatch({
              type: types.tipoDocumentacionPorSubTipoEfectorEliminar,
              payload: id
          })
          dispatch(finishSpinner())
      } else {
          throw body
      }

  } catch (error) {
      dispatch(finishSpinner())
      if (error.errores && error.errores.mensaje) {
          dispatch(startAlerta(error.errores.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
};
